import React from 'react'
import { Container } from 'react-bootstrap'
import team from '../Assets/Images/team.jpeg'
import SimpleSlider from '../Components/Slider/Slider'
import teams from '../Assets/Datas/team'
import { Helmet } from 'react-helmet-async'

const OurTeam = () => {
  return (
    <div>
      <Helmet>
        <title>Our Team</title>
        <meta
          name="description"
          content="We prioritize excellence by nurturing a team of skilled professionals dedicated to creating top-quality engine and gear oils. We foster an inclusive work environment that encourages growth, innovation, and collaboration."
        />
        <link rel="canonical" href="https://oyoyolubricant.com/company/team" />
      </Helmet>     
       <div className="bg-accent1 py-2 text-sm text-slate-500 underline cursor-pointer">
        <Container>
          <p>Oyoyo Lubricants &rarr; Our Team</p>
        </Container>
      </div>
      <div>
        <Container className="p-3 mb-8 ">
          <div className="relative h-48 md:h-72 w-full mb-8">
            <div
              className="h-full w-full rounded-lg shadow-lg"
              style={{
                backgroundImage: `url(${team})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}
            >
              <div className="absolute inset-0 bg-black bg-opacity-50 rounded-lg flex items-center justify-center">
                <h2 className='text-2xl md:text-4xl font-semibold text-white uppercase tracking-wider'>Our Team</h2>
              </div>
            </div>
            
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4 items-center w-full h-full">
                <div>
                    <p>
                    At Oyoyo, we prioritize excellence by nurturing a team of skilled professionals dedicated to creating top-quality engine and gear oils. We foster an inclusive work environment that encourages growth, innovation, and collaboration. By offering equal opportunities and a supportive atmosphere, we ensure that our team remains motivated and committed to delivering products that exceed customer expectations. Our focus on professional development and consumer satisfaction drives us to maintain the highest standards in everything we do, ensuring that Oyoyo remains a leader in the industry.
                    </p>
                </div>
                <SimpleSlider teams={teams}/>
            </div>
        </Container>
      </div>
    </div>
  )
}

export default OurTeam
